import { createFileRoute } from "@tanstack/react-router";

import { RoutePage, routeEntry } from "./routeTable";

const entry = routeEntry("/planning/issues");

export const Route = createFileRoute("/planning/issues/")({
  head: () => ({
    meta: [
      { title: "Planning issues — LevelLoad" },
      {
        name: "description",
        content: "What the last solve could not ship, and the limits it ran into.",
      },
      { property: "og:title", content: "Planning issues — LevelLoad" },
      {
        property: "og:description",
        content: "What the last solve could not ship, and the limits it ran into.",
      },
      { property: "og:type", content: "website" },
      { name: "twitter:card", content: "summary_large_image" },
    ],
  }),
  component: RouteComponent,
});

function RouteComponent() {
  return <RoutePage entry={entry} />;
}
